<form
  class="subscribe-form"
  [formGroup]="form"
  *ngIf="!userSubscribed && !successSubscription"
  [class.subscribe-processing]="processing"
  [class.subscribe-success]="sent"
>
  <div class="subscribe-form-content" *ngIf="!sent">
    <!-- if comming from type=all will display a different message -->

    <ng-container *ngIf="type === 'all'">
      <div
        class="subscribe-title type-all"
        [innerHTML]="strTitleAllTranslated"
        [attr.data-translate]="strTitleAll"
      ></div>
    </ng-container>
    <ng-container *ngIf="type !== 'all'">
      <div class="subscribe-title" [innerHTML]="strTitleTranslated" [attr.data-translate]="strTitle"></div>
    </ng-container>

    <!-- end message -->
    <div class="input-wrapper">
      <div class="p-col field-box attached subscribe-component" *ngIf="!processing; else loading">
        <input
          class="email-field"
          type="email"
          pInputText
          formControlName="email"
          [placeholder]="'public.commons.enterEmail' | translate"
        />

        <div *ngIf="permissionText" class="permission">
          <p-checkbox (onChange)="onCheckboxChanged($event)" [binary]="true"></p-checkbox>
          <span class="permissionText" [innerHTML]="getDecodeText(permissionText)" routeTransformer></span>
        </div>

        <div *ngIf="showCaptcha" class="showCaptcha">
          <re-captcha id="recaptcha" name="recaptcha" (resolved)="onCapchaResponse()" required></re-captcha>
        </div>

        <button class="button button-secondary" (click)="sendConsumerLead()">
          <span [attr.data-translate]="'public.commons.subscribe'">{{ 'public.commons.subscribe' | translate }}</span>
        </button>
      </div>
      <ng-container *ngIf="onError">
        <h3 class="result-msg" [attr.data-translate]="'public.commons.somethingWrong'">
          {{ 'public.commons.somethingWrong' | translate }}
        </h3>
      </ng-container>

      <div class="p-col-12 provide-email-error" *ngIf="touched && !processing">
        <small
          *ngIf="form.get('email').errors"
          class="text-danger"
          [attr.data-translate]="'public.error.provideEmail'"
          >{{ 'public.error.provideEmail' | translate }}</small
        >
      </div>
      <!-- Your email will be used for being notified message -->
      <ng-container *ngIf="type === 'all'">
        <p class="subscribe-desc" [attr.data-translate]="strDescAll">
          {{ strDescAllTranslated }}
        </p>
      </ng-container>
      <ng-container *ngIf="type !== 'all'">
        <p class="subscribe-desc" [attr.data-translate]="strDesc">
          {{ strDescTranslated }}
        </p>
      </ng-container>
      <!-- End message -->
    </div>
  </div>
  <ng-container *ngIf="sent && !hideOnSuccessSubscription">
    <h3 class="thanks-msg result-msg" [attr.data-translate]="strThanks">{{ strThanksTranslated }}</h3>
  </ng-container>
</form>

<ng-template #loading>
  <ush-loading-indicator fontSize="30px" height="auto"></ush-loading-indicator>
</ng-template>
